import axios from 'axios'

// The droplist parser service (DroplistParser repo, on Railway). Vercel rewrites /droplist/* to it, so the
// swiftsole session cookie goes along and the service checks it's an admin.
export const droplistApi = axios.create({ baseURL: '/droplist/api', withCredentials: true })

// Same guard as the affiliate client: anything but JSON (e.g. index.html from a missing rewrite) is an error.
droplistApi.interceptors.response.use((response) => {
    const type = String(response.headers['content-type'] || '')
    if (response.status !== 204 && !type.includes('application/json')) {
        return Promise.reject(new Error('The droplist service is not reachable.'))
    }
    return response
})

/** The service answers errors as { reason, message }; the message is written to be shown. */
export const droplistError = (error: unknown) => {
    if (axios.isAxiosError(error)) {
        const message = error.response?.data?.message
        if (typeof message === 'string' && message) return message
        if (error.response?.status === 403) return 'Admins only.'
    }
    return error instanceof Error ? error.message : 'Something went wrong. Please try again.'
}
